import React from "react";
import { 
  FormControl, 
  RadioGroup, 
  Grid, 
  Paper, 
  FormControlLabel, 
  Radio, 
  Typography,
  Box
} from "@mui/material";
import { formatCardDisplay } from './cardFormatting';

const ExistingCards = ({ 
  cards, 
  selectedCardIndex, 
  onCardSelection, 
  newlyAddedCardId 
}) => {
  // Função para verificar se o cartão está válido
  const isCardValid = (card) => {
    return card.vindi_payment_profile_id && card.vindi_payment_profile_id !== null;
  };


  if (cards && cards.length > 0) {
    cards.forEach((card, index) => {
      const numeroExibido = formatCardDisplay(card.masked_number);
      const cardValido = isCardValid(card);
    });
  } else {
  }
  
  if (!cards || cards.length === 0) {
    return null;
  }

  const shouldShowScroll = cards.length > 6;

  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <RadioGroup value={selectedCardIndex?.toString() || ""}>
        <Box 
          sx={shouldShowScroll ? { 
            maxHeight: { xs: '400px', sm: '400px', md: 'none' }, 
            overflowY: { xs: 'auto', sm: 'auto', md: 'visible' },
            overflowX: 'hidden'
          } : {}}
        >
          <Grid container spacing={2}>
            {cards.map((card, index) => {
              const cardValido = isCardValid(card);
              const isSelected = selectedCardIndex === index;
              const isNewCard = newlyAddedCardId === card.id;
              
              return (
                <Grid item xs={12} sm={6} key={card.id || index}>
                  <Paper 
                    sx={{ 
                      p: 1, 
                      cursor: cardValido ? 'pointer' : 'not-allowed',
                      border: isSelected ? 2 : 1,
                      borderColor: !cardValido ? '#757575' : (isSelected ? '#662D91' : 'grey.300'),
                      backgroundColor: !cardValido ? '#f5f5f5' : (isSelected ? '#f8f5ff' : 'white'),
                      opacity: cardValido ? 1 : 0.6,
                      overflow: 'hidden',
                      // Destacar visualmente o cartão recém-adicionado
                      ...(isNewCard && cardValido && {
                        backgroundColor: '#f3f0ff',
                        border: 2,
                        borderColor: 'success.main'
                      }),
                      '&:hover': cardValido ? {
                        borderColor: '#662D91',
                        backgroundColor: isSelected ? '#f8f5ff' : '#fafafa'
                      } : {},
                      transition: 'all 0.2s ease-in-out'
                    }}
                    onClick={() => cardValido && onCardSelection(card.id, index)}
                  >
                    <FormControlLabel
                      value={index.toString()}
                      control={
                        <Radio 
                          data-testid={`payment_existingCardRadio_${index}`}
                          checked={isSelected && cardValido} 
                          disabled={!cardValido}
                          sx={{
                            color: cardValido ? 'grey.400' : 'grey.300',
                            '&.Mui-checked': {
                              color: '#662D91'
                            },
                            '&.Mui-disabled': {
                              color: 'grey.300'
                            },
                            pl: 0,
                          }}
                        />
                      }
                      sx={{ width: '100%', minWidth: 0, margin: 0 }}
                      label={
                        <Box sx={{ 
                          display: 'flex', 
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          gap: 0.25,
                          width: '100%',
                          minWidth: 0
                        }}>
                          {/* Nome do titular do cartão */}
                          {card.holder_name && (
                            <Typography
                              sx={{
                                color: !cardValido ? '#757575' : (isSelected ? '#662D91' : 'text.primary'),
                                fontWeight: isSelected ? 600 : 500,
                                fontSize: { xs: '0.85rem', sm: '0.9rem', md: '0.95rem' },
                                transition: 'color 0.2s ease-in-out',
                                textDecoration: cardValido ? 'none' : 'line-through',
                                width: '100%',
                                wordBreak: 'break-word',
                                lineHeight: 1.2
                              }}
                            >
                              {card.holder_name}
                            </Typography>
                          )}
                          
                          {/* Nome da bandeira do cartão */}
                          <Typography
                            sx={{
                              color: !cardValido ? '#757575' : (isSelected ? '#662D91' : 'text.primary'),
                              fontWeight: isSelected ? 'bold' : 600,
                              fontSize: { xs: '0.9rem', sm: '0.85rem', md: '0.9rem' },
                              textTransform: 'uppercase',
                              transition: 'color 0.2s ease-in-out',
                              textDecoration: cardValido ? 'none' : 'line-through',
                              width: '100%',
                              lineHeight: 1.2
                            }}
                          >
                            {card.flag}
                          </Typography>
                          
                          {/* Número do cartão */}
                          <Typography
                            sx={{
                              color: !cardValido ? '#757575' : (isSelected ? '#662D91' : 'text.secondary'),
                              fontWeight: isSelected ? 500 : 'normal',
                              fontSize: { xs: '0.75rem', sm: '0.8rem' },
                              transition: 'color 0.2s ease-in-out',
                              textDecoration: cardValido ? 'none' : 'line-through',
                              width: '100%',
                              wordBreak: 'break-all',
                              lineHeight: 1.3
                            }}
                          >
                            {formatCardDisplay(card.masked_number)}
                          </Typography>
                          
                          {/* Indicador visual para cartão recém-adicionado */}
                          {isNewCard && cardValido && (
                            <Typography 
                              component="span"
                              variant="caption" 
                              sx={{ 
                                color: 'success.main', 
                                fontWeight: 'bold',
                                fontSize: { xs: '0.65rem', sm: '0.7rem' },
                                display: 'block',
                                mt: 0.25,
                                width: '100%',
                                lineHeight: 1.2
                              }}
                            >
                              (Novo)
                            </Typography>
                          )}
                          
                          {/* Mensagem de cartão inválido */}
                          {!cardValido && (
                            <Typography 
                              variant="caption" 
                              sx={{ 
                                color: '#757575', 
                                fontWeight: 'bold',
                                fontSize: { xs: '0.65rem', sm: '0.7rem' },
                                display: 'block',
                                mt: 0.25,
                                width: '100%',
                                wordBreak: 'break-word',
                                lineHeight: 1.2
                              }}
                            >
                              Indisponível, cadastre seu cartão novamente
                            </Typography>
                          )}
                        </Box>
                      }
                    />
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </RadioGroup>
    </FormControl>
  );
};

export default ExistingCards;